
















































import { Vue } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";
export default Vue.component("share-order-modal", {
  data() {
    return {
      staticContent,
     
    };
  },computed: {
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
    sharedOrderLink(){
      return this.$store.state.sharedOrderLink
    }
  },
  methods:{
     modalToggler(modalId, method) {
      return this.$root.modalToggler(modalId, method);
    },
    copyText() {
        let copyText = document.getElementById("order-share-link") as HTMLInputElement;
        copyText.focus();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        let tooltip = document.getElementById("order-copy-btn");
        tooltip.innerHTML = staticContent.restaurant.basket.copied
      },
      outFunc() {
        let tooltip = document.getElementById("order-copy-btn");
        tooltip.innerHTML = staticContent.restaurant.basket.copyToClipBoard;
      }
  }
})

